import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
//#region src/redux/modal-view/reducers.ts
var reducers_exports = /* @__PURE__ */ __exportAll({
	disposeModalView: () => disposeModalView,
	updateModalView: () => updateModalView
});
var updateModalView = (state, { payload }) => {
	const modalViews = state.modalViews ? [...state.modalViews] : [];
	const existingIndex = modalViews.findIndex((modalView) => modalView.id === payload.id);
	if (existingIndex !== -1) modalViews[existingIndex] = {
		...modalViews[existingIndex],
		...payload
	};
	else modalViews.push(payload);
	return {
		...state,
		modalViews
	};
};
var disposeModalView = (state, { payload }) => {
	if (payload) {
		const modalViews = state.modalViews ? [...state.modalViews] : [];
		const indexToDelete = modalViews.findIndex((modalView) => modalView.id === payload);
		if (indexToDelete !== -1) {
			modalViews.splice(indexToDelete, 1);
			return {
				...state,
				modalViews
			};
		}
	}
};
//#endregion
export { disposeModalView, reducers_exports, updateModalView };

//# sourceMappingURL=reducers.js.map